module.exports = __webpack_public_path__ + "static/media/outlook-icon.eaee678b.png";